export default {"src":"/_next/static/media/ISDA Logo.09028ab2.svg","height":41,"width":166,"blurWidth":0,"blurHeight":0};